import axios from "axios";

export default {
  methods: {
    /**
     * Método para retornar todas as unimeds
     * @return {Promise<Array<{ id: Number, codigo: Number, nomeFantasia: String, razaoSocial: String, textoExibicao: String}>>}
     */
    getAllUnimeds() {
      return axios.get(this.CriarUrl({ resource: "unimed/all" }));
    }
  }
};
